export default __webpack_public_path__ + "static/media/logoFullSize.a89236f8.png";